import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { getReportData } from '../../../api/reports';
import { Layout } from '../../../common/components';
import NoReports from '../../../common/components/noReport/noReport';
import { useSetLoading } from '../../../common/hooks/appearance';
import { monthlyReportTypes } from '../../../constants/reports';
import * as handlers from '../../../utils/handlers';
import GenerateTrust from '../components/generateTrust/generateTrust';
import TrustMonthlyReportData from '../components/tables/monthlyReportTable/TrustMonthlyReport';
import TrustTypes from '../components/trustTypes/trustTypes';

export default function TrustMonthlyReport() {
  const [loading, setLoading] = useState(false);
  const [applyFilters, setApplyFilters] = useState(false);
  const [showTable, setShowTable] = useState({
    show: false,
    tableName: '',
    tableData: [],
    fromDate: null,
    toDate: null,
    trustType: 0,
    needType: 0,
    totalResults: null,
    page: 1,
    limit: 5,
    isSearchResult: false,
    hasDownloadFunctionality: true,
    monthlyReportTypes: [],
  });

  useEffect(() => {
    if (applyFilters && showTable?.show) {
      generateTable(showTable.fromDate, showTable.toDate, showTable.reportType);
    }
    if (!showTable.show) {
      setApplyFilters(false);
    }
  }, [showTable]);

  const generateTable = async (fromDate, toDate, reportType) => {
    setApplyFilters(false);
    setShowTable({ ...showTable, fromDate, toDate });
    const requestParams = {
      trustType: showTable.trustType,
      needType: showTable.needType,
      startDate: fromDate,
      endDate: toDate,
      timezone: moment.tz.guess().toString(),
      spName: reportType,
    };
    setLoading(true);
    try {
      const response = await getReportData('trust_monthly_report', requestParams);

      setShowTable((state) => {
        const obj = {
          ...state,
          show: true,
          fromDate,
          toDate,
          reportType,
          isSearchResult: false,
          tableData: response.data.data || [],
          totalResults: response.data.data.length || 0,
        };
        return obj;
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handlers.apiErrorHandler(error);
    }
  };

  const getTitle = () => {
    switch (showTable.reportType) {
      case 'Trusted_Consumption_Items_With_AT_Changes':
        return 'Trust Item Consumption';
      case 'Trusted_Sales_Item':
        return 'Trust Sales Item';
      case 'Endowment_Care_Sales_Property':
        return 'Endowment Care Sales';
      default:
        return '';
    }
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  return (
    <Layout>
      <TrustTypes setShowTable={setShowTable} setApplyFilters={setApplyFilters} />
      <h3 className="account-heading">Monthly Automated Reports</h3>
      <GenerateTrust
        setShowTable={setShowTable}
        trustType={showTable.trustType}
        needType={showTable.needType}
        reportType={showTable.reportType}
        reportTypes={monthlyReportTypes}
        title="Trust Monthly Reports"
        description="Generate monthly reports"
        monthlyReport={[1]}
        onGenerateClick={generateTable}
      />
      <hr />
      {showTable.show ? (
        <TrustMonthlyReportData
          setShowTable={setShowTable}
          showTable={showTable}
          title={getTitle()}
          subtitle={`From: ${showTable?.fromDate} To: ${showTable?.toDate}`}
        />
      ) : (
        <div className="noreports-trust">
          <NoReports />
        </div>
      )}
    </Layout>
  );
}
